import React from 'react'
import betterspaceLogo from '@wellbeingxltd/fe-lib/images/dist/logo/betterspaceWordmarkColour.svg'
import './styles.scss'

function Logo() {
    return (
        <div className="betterspace-logo-container">
            <img src={betterspaceLogo} alt="Betterspace" />
        </div>
    )
}

export default Logo
